import { Accordion } from 'jl-design-system/components/accordion/Accordion';
import { AccordionItem } from 'jl-design-system/components/accordion/accordion-item/AccordionItem';
import Checkbox from 'jl-design-system/components/checkbox/Checkbox';
import OptionList from 'jl-design-system/components/option/OptionList';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { dateFilters } from './date-filters.constants';
import styles from './DateFilters.scss';

export class DateFilters extends PureComponent {
  state = {
    isDateFiltersListOpened: false,
  };

  componentDidMount() {
    const { activeFilters } = this.props;
    if (activeFilters.length) {
      this.setState({
        isDateFiltersListOpened: true,
      });
    }
  }

  render() {
    const { isDateFiltersListOpened } = this.state;
    const { activeFilters, onChange } = this.props;
    return (
      <Accordion className={styles.DateFilterAccordion}>
        <AccordionItem
          open={isDateFiltersListOpened}
          header={<h6 className={styles.DateFilterAccordionTitle}>Choose filters</h6>}
        >
          <OptionList isButtonList={false} className={styles.DateFilterOptionList}>
            {dateFilters.map(({ id, title }) => (
              <Checkbox
                name={id}
                label={title}
                checked={activeFilters.includes(id)}
                value={id}
                id={id}
                key={id}
                onChange={() => onChange(id)}
                data-testid="DateFilter"
              />
            ))}
          </OptionList>
        </AccordionItem>
      </Accordion>
    );
  }
}

DateFilters.propTypes = {
  activeFilters: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

DateFilters.defaultProps = {
  activeFilters: [],
};
